module.exports = __webpack_public_path__ + "media/images/front/about/aboutdba_point01-3-868654f0807cbda23b5769c8bc513887.jpg";